import { IApplicationState } from '../../types/redux';
import { INewbuildingDeveloperValuation } from '../../types/developerValuation/developerValuation';

export const selectDeveloperValuationData = (state: IApplicationState): INewbuildingDeveloperValuation | null => {
  return state.developerValuation.developerValuation;
};
